import { Component, HostListener, Input, OnChanges, OnInit, SimpleChanges, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Router } from "@angular/router";
import { DefaultComponent } from "src/app/default.component";
import { IconReplacePipe } from "src/pipes/icon-replace.pipe";
import { PrefixTemplate } from "../../PrefixTemplate";

@Component({
  selector: "app-template-html",
  templateUrl: "./template-html.component.html",
  imports: [IconReplacePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./template-html.component.less",
})
export class TemplateHTMLComponent<CONTROL, VALUE = CONTROL> extends DefaultComponent implements PrefixTemplate<CONTROL, VALUE>, OnInit, OnChanges {
  @Input({ required: true })
  public control: FormControl<CONTROL> | null;

  @Input({ required: true })
  public value: VALUE | null;

  @Input()
  public label: string | null;

  @Input()
  public showPlaceholderIfEmpty: boolean;

  private router: Router;

  protected _value: VALUE | null;

  public constructor() {
    super();
    this.router = inject(Router);
    this.control = null;
    this.value = null;
    this._value = null;
    this.label = null;
    this.showPlaceholderIfEmpty = true;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes["value"]) {
      this._value = this.parseValue(this.value);
    }
  }

  public ngOnInit(): void {
    if (!this.control) throw new Error("Undefined control");
  }

  @HostListener("click", ["$event"])
  public onLinkClick(event: PointerEvent): void {
    const element = <HTMLElement>event.target;
    if (element.nodeName === "A") {
      const link = element.getAttribute("href");
      if (link && link.startsWith("/")) {
        event.preventDefault();
        this.router.navigate([link]);
      }
    }
  }

  private parseValue(value: VALUE | null): VALUE | null {
    if (value === null || typeof value !== "string") return null;

    return value.replace(/(<img[^>]+src=['"])(\/images)/g, "$1/assets/images") as VALUE;
  }
}
